(function() {
  var body = document.querySelector('.faq__body');
  if (!body) return;

  var dts = body.querySelectorAll('dl > dt');

  dts.forEach(function(dt) {
    var dl = dt.parentNode;
    var dd = dt.nextElementSibling;
    if (!dl || !dd || dd.tagName !== 'DD') return;

    var inner = dd.innerHTML;
    dd.innerHTML = '<div class="faq__answer">' + inner + '</div>';

    dt.setAttribute('role', 'button');
    dl.setAttribute('aria-expanded', 'false');
    dt.setAttribute('tabindex', '0');
    dd.setAttribute('aria-hidden', 'true');

    var text = dt.innerHTML;
    dt.innerHTML = '<span class="faq__question">' + text + '</span>';

    dt.addEventListener('click', function() {
      toggle(dl, dd);
    });

    dt.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle(dl, dd);
      }
    });
  });

  function toggle(dl, dd) {
    var isOpen = dl.getAttribute('aria-expanded') === 'true';
    dl.setAttribute('aria-expanded', String(!isOpen));
    dd.setAttribute('aria-hidden', String(isOpen));
  }
})();
